/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 랜딩페이지 고객 문의 폼을 제출합니다.
 * @summary 고객 문의 이메일 전송
 */
export const contactControllerCreateInquiryBodyNameMin = 2;
export const contactControllerCreateInquiryBodyNameMax = 50;

export const contactControllerCreateInquiryBodyPhoneMax = 20;

export const contactControllerCreateInquiryBodyCompanyMax = 100;

export const contactControllerCreateInquiryBodyMessageMin = 10;
export const contactControllerCreateInquiryBodyMessageMax = 2000;

export const contactControllerCreateInquiryBody = zod
  .object({
    name: zod
      .string()
      .min(contactControllerCreateInquiryBodyNameMin)
      .max(contactControllerCreateInquiryBodyNameMax)
      .describe("문의자 이름"),
    email: zod.string().email().describe("문의자 이메일"),
    phone: zod
      .string()
      .max(contactControllerCreateInquiryBodyPhoneMax)
      .optional()
      .describe("문의자 전화번호"),
    company: zod
      .string()
      .max(contactControllerCreateInquiryBodyCompanyMax)
      .optional()
      .describe("회사명/사업자명"),
    inquiryType: zod
      .enum(["bug", "feedback", "supplier", "transaction", "general"])
      .describe("문의 유형"),
    message: zod
      .string()
      .min(contactControllerCreateInquiryBodyMessageMin)
      .max(contactControllerCreateInquiryBodyMessageMax)
      .describe("문의 내용"),
  })
  .strict();

export const contactControllerCreateInquiryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
